import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class OutsideProcessTypeService extends Service {
	constructor(injector: Injector) {
		super("OutsideProcessType", injector);
	}
}